"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDL = exports.ForesightObj = void 0;
const web3_js_1 = require("@solana/web3.js");
const prediction_market_1 = require("./idl/prediction_market");
Object.defineProperty(exports, "IDL", { enumerable: true, get: function () { return prediction_market_1.IDL; } });
const translateAddress_1 = require("./utils/translateAddress");
const axios_1 = __importDefault(require("axios"));
const token_instructions_1 = require("@project-serum/serum/lib/token-instructions");
const helpers_1 = require("./helpers");
const consts_1 = require("./consts");
const anchor_1 = require("@project-serum/anchor");
const getTokens_1 = require("./utils/getTokens");
const pluralize_1 = require("./utils/pluralize");
const closeAccountsTradeYes_1 = require("./generated/instructions/closeAccountsTradeYes");
const closeAccountsSellNo_1 = require("./generated/instructions/closeAccountsSellNo");
const redeemWinningYes_1 = require("./generated/instructions/redeemWinningYes");
const redeemWinningNo_1 = require("./generated/instructions/redeemWinningNo");
const closeAccountsBuyNo_1 = require("./generated/instructions/closeAccountsBuyNo");
const cancelTradeYes_1 = require("./generated/instructions/cancelTradeYes");
const TradeYes_1 = require("./generated/accounts/TradeYes");
const TradeNo_1 = require("./generated/accounts/TradeNo");
const MarketMetadata_1 = require("./generated/accounts/MarketMetadata");
const Category_1 = require("./generated/accounts/Category");
const Bracket_1 = require("./generated/accounts/Bracket");
const Market_1 = require("./generated/accounts/Market");
const MarketList_1 = require("./generated/accounts/MarketList");
const cancelBuyNo_1 = require("./generated/instructions/cancelBuyNo");
const cancelSellNo_1 = require("./generated/instructions/cancelSellNo");
const types_1 = require("./generated/types");
const trades_1 = require("./primitives/trades");
const INIT = "INIT";
const DEFAULT = "DEFAULT";
function genCloseAccountsBase(user, pubkeys) {
    const { bracket, dexProgram, market, serumMarket, internalTokenAuth } = pubkeys;
    return {
        user,
        market,
        bracket,
        serumMarket,
        internalTokenAuth,
        dexProgram,
        tokenProgram: token_instructions_1.TOKEN_PROGRAM_ID,
    };
}
function generateCloseAccountsTradeYesAccObj(user, pubkeys) {
    const closeAccountsBase = genCloseAccountsBase(user, pubkeys);
    const { lockedYesFUsdc, unlockedYes, tradeYesAccount, openOrdersYes } = pubkeys;
    return {
        ...closeAccountsBase,
        tradeYes: tradeYesAccount,
        openOrders: openOrdersYes,
        unlockedYes,
        lockedFUsdc: lockedYesFUsdc,
    };
}
function generateCloseAccountsBuyNoAccObj(user, pubkeys) {
    const closeAccountsBase = genCloseAccountsBase(user, pubkeys);
    const { unlockedNo, tradeNoAccount, openOrdersBuyNo, lockedBuyNoFUsdc, lockedBuyNoYes, } = pubkeys;
    return {
        ...closeAccountsBase,
        tradeNo: tradeNoAccount,
        openOrders: openOrdersBuyNo,
        lockedYes: lockedBuyNoYes,
        unlockedNo,
        lockedFUsdc: lockedBuyNoFUsdc,
    };
}
function generateCloseAccountsSellNoAccObj(user, pubkeys) {
    const closeAccountsBase = genCloseAccountsBase(user, pubkeys);
    const { tradeNoAccount, openOrdersSellNo, lockedSellNoFUsdc, lockedSellNoYes, lockedSellNoNo, } = pubkeys;
    return {
        ...closeAccountsBase,
        tradeNo: tradeNoAccount,
        openOrders: openOrdersSellNo,
        lockedYes: lockedSellNoYes,
        lockedNo: lockedSellNoNo,
        lockedFUsdc: lockedSellNoFUsdc,
    };
}
function genRedeemBase(user, pubkeys) {
    const { bracket, usdcVault, market, serumMarket, marketPnl, internalUsdc } = pubkeys;
    return {
        user,
        market,
        bracket,
        serumMarket,
        usdcVault,
        tokenProgram: token_instructions_1.TOKEN_PROGRAM_ID,
        marketPnl,
        internalUsdc,
    };
}
function generateRedeemWinningYesAccObj(user, pubkeys) {
    const redeemBase = genRedeemBase(user, pubkeys);
    const { unlockedYes, yesMint, tradeYesAccount, internalUsdc } = pubkeys;
    return {
        ...redeemBase,
        tradeYes: tradeYesAccount,
        yesMint,
        unlockedYes,
        internalUsdc,
    };
}
function generateRedeemWinningNoAccObj(user, pubkeys) {
    const redeemBase = genRedeemBase(user, pubkeys);
    const { unlockedNo, noMint, tradeNoAccount } = pubkeys;
    return {
        ...redeemBase,
        tradeNo: tradeNoAccount,
        noMint,
        unlockedNo,
    };
}
class ForesightObj {
    constructor(connection, program, usdcMint, userUsdc, markets, wallet, selectedMarket, selectedOpenOrders, selectedUnlockedYesTokens, selectedUnlockedNoTokens, selectedOpenInterest, ids, marketList, internalUsdc) {
        this.connection = connection;
        this.program = program;
        this.usdcMint = usdcMint;
        this.userUsdc = userUsdc;
        this.markets = markets;
        this.wallet = wallet;
        this.selectedMarket = selectedMarket;
        this.selectedOpenOrders = selectedOpenOrders;
        this.selectedUnlockedYesTokens = selectedUnlockedYesTokens;
        this.selectedUnlockedNoTokens = selectedUnlockedNoTokens;
        this.selectedOpenInterest = selectedOpenInterest;
        this.ids = ids;
        this.marketList = marketList;
        this.internalUsdc = internalUsdc;
    }
    async selectMarket({ market, signal, }) {
        const provider = this.program.provider;
        await (0, helpers_1.selectMarket)({
            market,
            provider,
            signal,
            dexId: this.ids.DEX_PID,
            customCallback: ({ type, action }) => {
                if (type === consts_1.CALLBACK_TYPES.SUCCESS) {
                    this.selectedMarket = action.market.market;
                    this.selectedOpenOrders = action.market.openOrders;
                    this.selectedUnlockedYesTokens = action.market.unlockedYesTokens;
                    this.selectedUnlockedNoTokens = action.market.unlockedNoTokens;
                }
                else {
                    this.selectedMarket = action.market.market;
                    this.selectedOpenOrders = {};
                    this.selectedUnlockedYesTokens = {};
                    this.selectedUnlockedNoTokens = {};
                }
            },
        });
    }
    updateUserUsdc({ userUsdc }) {
        this.userUsdc = userUsdc;
    }
    async refetchData() {
        const loadedMarkets = (await (0, helpers_1.fetchPredictionMarkets)({
            marketList: this.marketList,
            provider: this.program.provider,
            DEX_PID: this.ids.DEX_PID,
            userUsdc: this.userUsdc,
        }));
        await this.selectMarket({
            market: this.selectedMarket,
        });
        this.markets = loadedMarkets;
    }
    async cancel({ market, customCallback = () => { }, type, side, orderId, marketList, config, }) {
        const { program } = this;
        const { provider } = program;
        let marketToUse = market || this.selectedMarket;
        const { pubkeys } = marketToUse;
        let marketsToUse = marketList || this.marketList;
        const cancelMarketType = consts_1.CANCEL_MARKET_TYPES[type];
        const user = provider.wallet.publicKey;
        let ix;
        if (cancelMarketType === consts_1.CANCEL_MARKET_TYPES[consts_1.MARKET_TYPE.BUY_YES]) {
            const accounts = (0, trades_1.generateTradeYesAccObj)(provider, pubkeys);
            const sideVariant = consts_1.SideMap[side];
            const args = { side: sideVariant, orderId };
            ix = (0, cancelTradeYes_1.cancelTradeYes)(args, accounts);
        }
        else if (cancelMarketType === consts_1.CANCEL_MARKET_TYPES[consts_1.MARKET_TYPE.BUY_NO]) {
            const accounts = (0, trades_1.generateBuyNoAccObj)(provider, pubkeys);
            ix = (0, cancelBuyNo_1.cancelBuyNo)({ orderId }, accounts);
        }
        else {
            const accounts = (0, trades_1.generateSellNoAccObj)(provider, pubkeys);
            ix = (0, cancelSellNo_1.cancelSellNo)({ orderId }, accounts);
        }
        const tx = new web3_js_1.Transaction().add(ix);
        try {
            await provider.send(tx);
        }
        catch (e) {
            console.error(e);
        }
        customCallback({
            msg: `cancel ${type}!`,
            status: "orderId starting to be cancelled",
        });
        const loadedMarkets = (await (0, helpers_1.fetchPredictionMarkets)({
            marketList: marketsToUse,
            provider,
            DEX_PID: this.ids.DEX_PID,
            userUsdc: this.userUsdc,
        }));
        const newMarket = loadedMarkets.find((item) => {
            if (item.details.bracket.id === market.details.bracket.id &&
                item.details.bracket.marketId === market.details.bracket.marketId &&
                item.details.bracket.marketListId.toString() ==
                    market.details.bracket.marketListId.toString()) {
                return true;
            }
        });
        if (newMarket) {
            await this.selectMarket({
                market: newMarket,
                config,
            });
        }
        this.markets = loadedMarkets;
    }
    async closeAccount({ type, market, }) {
        const { program } = this;
        const { provider } = program;
        const user = provider.wallet.publicKey;
        let marketToUse = market || this.selectedMarket;
        const { pubkeys } = marketToUse;
        let ix;
        if (type === consts_1.CLOSE_ACCOUNTS_BUY_NO) {
            const accounts = generateCloseAccountsBuyNoAccObj(user, pubkeys);
            ix = (0, closeAccountsBuyNo_1.closeAccountsBuyNo)(accounts);
        }
        else if (type === consts_1.CLOSE_ACCOUNTS_SELL_NO) {
            const accounts = generateCloseAccountsSellNoAccObj(user, pubkeys);
            ix = (0, closeAccountsSellNo_1.closeAccountsSellNo)(accounts);
        }
        else if (type === consts_1.CLOSE_ACCOUNTS_TRADE_YES) {
            const accounts = generateCloseAccountsTradeYesAccObj(user, pubkeys);
            ix = (0, closeAccountsTradeYes_1.closeAccountsTradeYes)(accounts);
        }
        else {
            throw new Error(`Unrecognized type: ${type}`);
        }
        const tx = new web3_js_1.Transaction().add(ix);
        await provider.send(tx);
    }
    async redeem({ close = true, market, }) {
        const { program } = this;
        const { provider } = program;
        const user = provider.wallet.publicKey;
        let marketToUse = market || this.selectedMarket;
        const { pubkeys } = marketToUse;
        let txn = new web3_js_1.Transaction();
        if (close) {
            // if trade yes:
            const tradeYesAccountData = await TradeYes_1.TradeYes.fetch(provider.connection, pubkeys.tradeYesAccount);
            const tradeNoAccountData = await TradeNo_1.TradeNo.fetch(provider.connection, pubkeys.tradeNoAccount);
            const hasSellNo = !!tradeNoAccountData?.hasSellNoBeenInit;
            if (tradeYesAccountData) {
                txn.add((0, closeAccountsTradeYes_1.closeAccountsTradeYes)(generateCloseAccountsTradeYesAccObj(user, pubkeys)));
            }
            // if buyNo
            if (tradeNoAccountData) {
                txn.add((0, closeAccountsBuyNo_1.closeAccountsBuyNo)(generateCloseAccountsBuyNoAccObj(user, pubkeys)));
            }
            // if sellNo
            if (hasSellNo) {
                const closeAccountsSellNoAccObj = generateCloseAccountsSellNoAccObj(user, pubkeys);
                txn.add((0, closeAccountsSellNo_1.closeAccountsSellNo)(closeAccountsSellNoAccObj));
            }
            // INSTRUCTIONS
            // if the bracket won redeem yes else redeem no.
            // if has tradeYes tokens.
            txn.add((0, redeemWinningYes_1.redeemWinningYes)(generateRedeemWinningYesAccObj(user, pubkeys)));
            // if hsa tradeNo tokens.
            const redeemWinningNoAccObj = generateRedeemWinningNoAccObj(user, pubkeys);
            txn.add((0, redeemWinningNo_1.redeemWinningNo)(redeemWinningNoAccObj));
            await program.provider.send(txn);
        }
    }
    async order({ type = consts_1.MARKET_TYPE.BUY_YES, limitPrice, coinAmount, orderType = new types_1.OrderType.Limit(), market, marketList, clientOrderId = 0, isMarketOrder, onEventChangeCallback = () => { }, }) {
        const { program } = this;
        const { provider } = program;
        let marketsToUse = marketList || this.marketList;
        const { pubkeys } = market;
        let tradeAccountData;
        const pubkey = pubkeys[consts_1.MARKET_TYPE_TO_TRADE_ACCOUNT_KEY[type]];
        const acc_name = consts_1.MARKET_TYPE_TO_TRADE_ACCOUNT[type];
        if (acc_name === consts_1.TRADE_YES) {
            tradeAccountData = await TradeYes_1.TradeYes.fetch(provider.connection, pubkey);
        }
        else {
            tradeAccountData = await TradeNo_1.TradeNo.fetch(provider.connection, pubkey);
        }
        const limitPriceBN = new anchor_1.BN(Number(limitPrice) * 10 ** 6);
        const coinAmountBN = new anchor_1.BN(Number(coinAmount) * 10 ** 6);
        let newLimitPrice = limitPriceBN.toNumber();
        let newCoinAmount = coinAmountBN.toNumber();
        if (newLimitPrice < 1000 || newLimitPrice > 999000) {
            onEventChangeCallback({
                title: "❌ ERROR - INVALID PRICE",
                msg: `You must enter a number between least .1 and 99.9 cents in order to place an order`,
                type: "ERROR",
            });
        }
        else if (newCoinAmount < 1000000) {
            onEventChangeCallback({
                title: "❌ ERROR - INVALID AMOUNT",
                msg: `You must enter a quantity greater or equal to 1 in order to place an order`,
                type: "ERROR",
            });
        }
        else {
            onEventChangeCallback({
                title: "⌛ Starting Transaction",
                msg: isMarketOrder
                    ? `Market order to ${(0, consts_1.MARKET_TYPE_ORDER_AMOUNT)({
                        type,
                        amount: coinAmount,
                    })} ${(0, pluralize_1.pluralize)({
                        amount: coinAmount,
                        text: "token",
                    })} for '${market.details.description}'

            Please check your wallet to confirm the details.`
                    : `Starting transaction on '${market.details.description}' to ${(0, consts_1.MARKET_TYPE_ORDER_AMOUNT)({
                        type,
                        amount: coinAmount,
                    })} ${(0, pluralize_1.pluralize)({
                        amount: coinAmount,
                        text: "token",
                    })} for ${(limitPrice * 100).toFixed(1)}¢


               Please check your wallet to confirm.`,
                type: "STARTING",
            });
            const checkHasAccountData = () => {
                if (tradeAccountData) {
                    if (type === consts_1.MARKET_TYPE.SELL_NO) {
                        const accData = tradeAccountData;
                        return !!accData.hasSellNoBeenInit;
                    }
                }
                return !!tradeAccountData;
            };
            let handleOrder;
            if (checkHasAccountData()) {
                try {
                    let tradeIx = await (0, trades_1.createOrderIx)({
                        constArgs: {
                            limitPrice: limitPriceBN,
                            coinAmount: coinAmountBN,
                            orderType,
                            clientOrderId: new anchor_1.BN(clientOrderId),
                        },
                        type,
                        pubkeys,
                        provider,
                    });
                    let orderTx = new web3_js_1.Transaction().add(tradeIx);
                    let handleOrder;
                    try {
                        handleOrder = await provider.send(orderTx);
                    }
                    catch (e) {
                        onEventChangeCallback({
                            title: `❌ ${e.message || e.msg || e.toString()}`,
                            msg: "",
                            type: "ERROR",
                        });
                        return;
                    }
                    onEventChangeCallback({
                        title: "⌛ Refetching newest data",
                        msg: `Finished ${handleOrder}
            
          Refetching Data...`,
                        type: "FETCHING",
                    });
                }
                catch (e) {
                    onEventChangeCallback({
                        title: `❌ ${e.message || e.msg || e.toString()}`,
                        msg: "",
                        type: "ERROR",
                    });
                }
                const loadedMarkets = (await (0, helpers_1.fetchPredictionMarkets)({
                    marketList: marketsToUse,
                    provider,
                    DEX_PID: this.ids.DEX_PID,
                    userUsdc: this.userUsdc,
                }));
                const newMarket = loadedMarkets.find((item) => {
                    if (item.details.bracket.id === market.details.bracket.id &&
                        item.details.bracket.marketId === market.details.bracket.marketId &&
                        item.details.bracket.marketListId.toString() ==
                            market.details.bracket.marketListId.toString()) {
                        return true;
                    }
                });
                await this.selectMarket({
                    market: newMarket,
                });
                const [newUserUsdc] = await (0, getTokens_1.getOwnedTokenAccounts)(this.usdcMint, provider.wallet.publicKey, program);
                onEventChangeCallback({
                    title: "🎉 Finished Transaction!",
                    msg: `
              Finished! If you see some weird behavior, please make the
              confirmation status is FINALIZED first.
         `,
                    type: "FINISHED",
                });
                this.userUsdc = newUserUsdc;
                this.markets = loadedMarkets;
            }
            else {
                let preInstructions = await (0, trades_1.generateMarketRequirements)({
                    provider,
                    pubkeys,
                    usdcMint: this.usdcMint,
                });
                function generateInitAndOrderTransaction() {
                    let initIx;
                    let initTransaction;
                    let tradeIx;
                    let orderTransaction;
                    initIx = (0, trades_1.createOrderAccountIx)({
                        type,
                        provider,
                        pubkeys,
                    });
                    tradeIx = (0, trades_1.createOrderIx)({
                        type,
                        provider,
                        pubkeys,
                        constArgs: {
                            limitPrice: limitPriceBN,
                            coinAmount: coinAmountBN,
                            orderType,
                            clientOrderId: new anchor_1.BN(clientOrderId),
                        },
                    });
                    initTransaction = new web3_js_1.Transaction().add(...preInstructions, initIx);
                    orderTransaction = new web3_js_1.Transaction().add(tradeIx);
                    return [initTransaction, orderTransaction];
                }
                try {
                    let [initTransaction, orderTransaction] = generateInitAndOrderTransaction();
                    try {
                        await program.provider.sendAll([
                            { tx: initTransaction },
                            { tx: orderTransaction },
                        ]);
                        onEventChangeCallback({
                            msg: `⌛ Completed ${consts_1.MARKET_TYPE_ORDER_STRINGS[type]} order! Refetching Data...`,
                            type: "FETCHING",
                        });
                    }
                    catch (e) {
                        onEventChangeCallback({
                            title: `❌ ${e.msg || e.toString()}`,
                            msg: e.msg,
                            type: "ERROR",
                        });
                        return;
                    }
                }
                catch (e) {
                    onEventChangeCallback({
                        title: `❌ ${e.msg || e.toString()}`,
                        msg: e.msg,
                        type: "ERROR",
                    });
                    return;
                }
                onEventChangeCallback({
                    msg: `⌛ Completed ${consts_1.MARKET_TYPE_ORDER_STRINGS[type]} order! Refetching Data...`,
                    type: "FETCHING",
                });
                const loadedMarkets = await (0, helpers_1.fetchPredictionMarkets)({
                    marketList: marketsToUse,
                    provider,
                    DEX_PID: this.ids.DEX_PID,
                    userUsdc: this.userUsdc,
                });
                const newMarket = loadedMarkets.find((item) => {
                    if (item.details.bracket.id === market.details.bracket.id &&
                        item.details.bracket.marketId === market.details.bracket.marketId &&
                        item.details.bracket.marketListId.toString() ==
                            market.details.bracket.marketListId.toString()) {
                        return true;
                    }
                });
                await this.selectMarket({
                    market: newMarket,
                });
                const [newUserUsdc] = await (0, getTokens_1.getOwnedTokenAccounts)(this.usdcMint, provider.wallet.publicKey, program);
                onEventChangeCallback({
                    msg: `🎉 Reloaded Data for your ${consts_1.MARKET_TYPE_ORDER_STRINGS[type]} order!`,
                    type: "FINISHED",
                });
                this.markets = loadedMarkets;
                this.userUsdc = newUserUsdc;
            }
        }
    }
    async updateDataWithWallet({ wallet, reselectMarket = false, marketList, }) {
        const { connection, program } = this;
        let marketsToUse = marketList || this.marketList;
        const provider = new anchor_1.Provider(connection, { ...wallet, publicKey: wallet?.publicKey }, { commitment: "confirmed" });
        if (wallet.publicKey) {
            const [userUsdc, internalUsdc] = await (0, getTokens_1.getOwnedTokenAccounts)(this.usdcMint, wallet.publicKey, program);
            this.userUsdc = userUsdc;
            this.internalUsdc = internalUsdc;
        }
        const loadedMarkets = (await (0, helpers_1.fetchPredictionMarkets)({
            marketList: marketsToUse,
            provider,
            DEX_PID: this.ids.DEX_PID,
            userUsdc: this.userUsdc,
        }));
        this.markets = loadedMarkets;
        if (reselectMarket) {
            await this.selectMarket({
                market: this.selectedMarket,
            });
        }
        this.wallet = wallet;
    }
    static async create({ connection, marketList, wallet, opts = {
        commitment: "confirmed",
    }, selectedMarket, usdcMint, userUsdc, }) {
        // let userUsdc = null;
        const ids = (0, consts_1.getEndpointConfig)(connection.rpcEndpoint);
        const providerPublickKey = new web3_js_1.PublicKey("EKbSnNyE3Gf7g6YfWjCknQUNGKz1r4hoCXUDUrGhZDXX");
        const provider = new anchor_1.Provider(connection, wallet || {
            publicKey: providerPublickKey,
        }, opts);
        const program = new anchor_1.Program(prediction_market_1.IDL, consts_1.PROGRAM_ID_PUBKEY, provider);
        const useUsdcMint = usdcMint ?? ids?.USDC_MINT_ID;
        let useUserUsdc = userUsdc;
        let useInternalUsdc;
        if (wallet?.publicKey && !userUsdc) {
            try {
                const [newUserUsdc, internalUsdc] = await (0, getTokens_1.getOwnedTokenAccounts)(useUsdcMint, provider.wallet.publicKey, program);
                useUserUsdc = newUserUsdc;
                useInternalUsdc = internalUsdc;
            }
            catch (e) {
                console.error(e, "error loading user usdc");
            }
        }
        const markets = (await (0, helpers_1.fetchPredictionMarkets)({
            marketList,
            provider,
            DEX_PID: ids.DEX_PID,
            userUsdc: useUserUsdc,
        }));
        const newSelectedMarket = markets.find((item) => {
            return (item.details.bracket.id[0].toString() === selectedMarket?.bracketId &&
                item.details.bracket.marketId[0].toString() ===
                    selectedMarket?.marketId &&
                item.marketListIdString === selectedMarket.marketListId);
        });
        const selectedMarketResult = await (0, helpers_1.selectMarket)({
            provider,
            market: newSelectedMarket || markets[0],
            dexId: ids.DEX_PID,
        });
        const foresight = new ForesightObj(connection, program, useUsdcMint, useUserUsdc, markets, provider.wallet, selectedMarketResult.market, selectedMarketResult.openOrders, selectedMarketResult.unlockedYesTokens, selectedMarketResult.unlockedNoTokens, selectedMarketResult.openInterest, ids, marketList, useInternalUsdc);
        return foresight;
    }
    static async getMarketList({ connection, opts = {}, categoryId, }) {
        const ids = (0, consts_1.getEndpointConfig)(connection.rpcEndpoint);
        let idToUse = typeof categoryId === "string"
            ? Buffer.from(categoryId.padEnd(20))
            : categoryId;
        let [category] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("category"), idToUse], consts_1.PROGRAM_ID_PUBKEY);
        const catData = await Category_1.Category.fetch(connection, category);
        const marketList = catData.marketListIds.map((marketListId) => {
            let [marketListPubkey] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("market_list"), Uint8Array.from(marketListId)], consts_1.PROGRAM_ID_PUBKEY);
            return marketListPubkey;
        });
        const mapAll = marketList.map((item) => (0, translateAddress_1.translateAddress)(item).toBase58());
        const dataToDecode = await axios_1.default.post(connection.rpcEndpoint, {
            jsonrpc: "2.0",
            id: "1",
            method: "getMultipleAccounts",
            params: [
                mapAll,
                {
                    commitment: opts.commitment || "confirmed",
                },
            ],
        });
        const allMarketLists = dataToDecode.data.result.value.map((marketList, i) => {
            const myBuffer = Buffer.from(marketList.data[0], marketList.data[1]);
            const details = MarketList_1.MarketList.decode(myBuffer);
            return { ...details, marketListId: catData.marketListIds[i] };
        });
        let listOfMarkets = [];
        await Promise.all(allMarketLists.map(async (marketList) => {
            const allMarkets = await (0, helpers_1.marketFetcher)(marketList);
            const allBrackets = await (0, helpers_1.bracketFetcher)(marketList);
            const allMarketsToFetchData = allMarkets
                .filter((i) => !!i?.market)
                .map((item) => {
                return (0, translateAddress_1.translateAddress)(item.market).toBase58();
            });
            const allMarketMetaDataToFetch = allMarkets
                .filter((i) => !!i?.market)
                .map((item) => {
                return (0, translateAddress_1.translateAddress)(item.marketMetadata).toBase58();
            });
            const allBracketsToFetchData = allBrackets
                .filter((i) => !!i?.bracket)
                .map((item) => (0, translateAddress_1.translateAddress)(item.bracket).toBase58());
            const commitment = opts.commitment || "confirmed";
            const dataToDecode = await axios_1.default.post(connection.rpcEndpoint, [
                {
                    jsonrpc: "2.0",
                    id: "1",
                    method: "getMultipleAccounts",
                    params: [
                        allMarketsToFetchData,
                        {
                            commitment: commitment,
                        },
                    ],
                },
                {
                    jsonrpc: "2.0",
                    id: "1",
                    method: "getMultipleAccounts",
                    params: [
                        allMarketMetaDataToFetch,
                        {
                            commitment: commitment,
                        },
                    ],
                },
                {
                    jsonrpc: "2.0",
                    id: "1",
                    method: "getMultipleAccounts",
                    params: [
                        allBracketsToFetchData,
                        {
                            commitment: commitment,
                        },
                    ],
                },
            ]);
            const allMarketData = dataToDecode.data[0].result.value.map((market) => {
                const encoded = market.data[0];
                const encoding = market.data[1];
                const myBuffer = Buffer.from(encoded, encoding);
                return Market_1.Market.decode(myBuffer);
            });
            const allMarketMetaData = dataToDecode.data[1].result.value.map(function (marketMetadata) {
                const encoded = marketMetadata.data[0];
                const encoding = marketMetadata.data[1];
                const myBuffer = Buffer.from(encoded, encoding);
                return MarketMetadata_1.MarketMetadata.decode(myBuffer);
            });
            const allBracketData = dataToDecode.data[2].result.value.map((bracket) => {
                const myBuffer = Buffer.from(bracket.data[0], bracket.data[1]);
                return Bracket_1.Bracket.decode(myBuffer);
            });
            allMarketMetaData.map((i, index) => {
                const category = Buffer.from(idToUse)?.toString();
                if (allBracketData[index]) {
                    listOfMarkets.push((0, helpers_1.makeMarketMetadataAndBracket)(i, category, allMarketData[index], allBracketData[index]));
                }
            });
        }));
        return listOfMarkets.sort((a, b) => {
            if (a.metadata.marketEnd === b.metadata?.marketEnd) {
                if (a.metadata?.description !== b.metadata?.description) {
                    return ("" + a.metadata?.description).localeCompare(b.metadata?.description);
                }
                return ("" + a.marketListIdString).localeCompare(b.marketListIdString);
            }
            return a.metadata.marketEnd - b.metadata.marketEnd;
        });
    }
    static async getMarketDetails({ bracketId, marketListId, marketId, connection, wallet = null, opts = {}, }) {
        const ids = (0, consts_1.getEndpointConfig)(connection.rpcEndpoint);
        const providerPublickKey = new web3_js_1.PublicKey("EKbSnNyE3Gf7g6YfWjCknQUNGKz1r4hoCXUDUrGhZDXX");
        const provider = new anchor_1.Provider(connection, wallet ||
            {
                publicKey: providerPublickKey,
            }, opts);
        let [marketListPubkey] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("market_list"), marketListId], consts_1.PROGRAM_ID_PUBKEY);
        let marketListData = await MarketList_1.MarketList.fetch(provider.connection, marketListPubkey);
        if (marketListData?.numMarkets > 0) {
            let [bracket] = anchor_1.utils.publicKey.findProgramAddressSync([
                Buffer.from("bracket"),
                Uint8Array.from([bracketId]),
                Buffer.from([marketId]),
                marketListId,
            ], consts_1.PROGRAM_ID_PUBKEY);
            let [market] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("market"), Buffer.from([marketId]), marketListId], consts_1.PROGRAM_ID_PUBKEY);
            let [marketMetadata] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("market_metadata"), Buffer.from([marketId]), marketListId], consts_1.PROGRAM_ID_PUBKEY);
            const [marketDetails, marketMetadataDetails, bracketDetails] = await Promise.all([
                Market_1.Market.fetch(provider.connection, market),
                MarketMetadata_1.MarketMetadata.fetch(provider.connection, marketMetadata),
                Bracket_1.Bracket.fetch(provider.connection, bracket),
            ]);
            const metadata = {
                ...marketMetadataDetails,
                title: Buffer.from(marketMetadataDetails.title).toString(),
                rules: Buffer.from(marketMetadataDetails.rules).toString(),
                description: Buffer.from(marketMetadataDetails.description).toString(),
                marketName: Buffer.from(marketMetadataDetails.marketName).toString(),
                image: Buffer.from(marketMetadataDetails.image).toString(),
                marketEnd: marketMetadataDetails.marketEnd.toNumber() || "N/A",
            };
            return {
                market: marketDetails,
                metadata,
                bracket: bracketDetails,
                marketListIdString: marketListId.toString(),
            };
        }
        else {
            return "Invalid Page";
        }
    }
    async settle({}) { }
    async consumeEvents({}) { }
    async fetchData({}) { }
}
exports.ForesightObj = ForesightObj;
//# sourceMappingURL=foresight-sdk.js.map